export const INTERCOM_APP_ID = process.env.INTERCOM_APP_ID;
